// extracted by mini-css-extract-plugin
export default {"rating":"NY+8PLC+","left":"rbm+9NKp","image":"RoZZDq20","right":"m6DZ-tIG"};